import { render, staticRenderFns } from "./ListaVentas.vue?vue&type=template&id=cfacf354&scoped=true"
import script from "./ListaVentas.vue?vue&type=script&lang=js"
export * from "./ListaVentas.vue?vue&type=script&lang=js"
import style0 from "./ListaVentas.vue?vue&type=style&index=0&id=cfacf354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfacf354",
  null
  
)

export default component.exports